import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelectedAccount } from '@ibk/shared-auth';
import { useGetHomePermissions, useInstructionsPermissioning } from '@ibk/shared-permissioning';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { localStorageService, StorageKeys } from '@ibk/shared-utils';
import { sharedUiTranslations } from '../../translations';
import ProfileMenuItem from '../ProfileMenuItem';
export const ProfileMenuPaymentsItemBase = () => {
    const { t } = useTranslation();
    const [paymentsCount, setPaymentsCount] = useState(0);
    const { canApprovePaymentLinks, showApprovePaymentLinks } = useInstructionsPermissioning();
    const { hasAccountPjPermission } = useGetHomePermissions();
    const { selectedAccount } = useSelectedAccount();
    const navigate = useNavigate();
    useEffect(() => {
        if (!selectedAccount?.id) {
            return;
        }
        const loadPaymentsCount = async () => {
            const storedTotal = await localStorageService.getItem(StorageKeys.PendingPaymentsTotal);
            if (typeof storedTotal === 'number') {
                setPaymentsCount(storedTotal);
            }
            else {
                setPaymentsCount(0);
            }
        };
        loadPaymentsCount();
        const retryTimer = setTimeout(() => {
            loadPaymentsCount();
        }, 600);
        const handleCustomStorageChange = (event) => {
            if (event.detail?.key === StorageKeys.PendingPaymentsTotal) {
                loadPaymentsCount();
            }
        };
        const handlePaymentChange = () => {
            setTimeout(loadPaymentsCount, 100);
        };
        const handleAccountChange = () => {
            setPaymentsCount(0);
            setTimeout(loadPaymentsCount, 200);
        };
        window.addEventListener('localStorageChange', handleCustomStorageChange);
        window.addEventListener('payment-approved', handlePaymentChange);
        window.addEventListener('payment-reproved', handlePaymentChange);
        window.addEventListener('account-changed', handleAccountChange);
        return () => {
            clearTimeout(retryTimer);
            window.removeEventListener('localStorageChange', handleCustomStorageChange);
            window.removeEventListener('payment-approved', handlePaymentChange);
            window.removeEventListener('payment-reproved', handlePaymentChange);
            window.removeEventListener('account-changed', handleAccountChange);
        };
    }, [selectedAccount?.id]);
    const hasApprovalPermissions = canApprovePaymentLinks && showApprovePaymentLinks;
    const relativeTitle = hasApprovalPermissions
        ? t('profile-menu-item.approve-payment-requests')
        : t('profile-menu-item.my-payment-requests');
    const formatPaymentsCount = (count) => {
        if (count === 0) {
            return '';
        }
        return count >= 10 ? '10+' : String(count);
    };
    if (!showApprovePaymentLinks) {
        return null;
    }
    if (!selectedAccount) {
        return null;
    }
    if (!hasAccountPjPermission) {
        return null;
    }
    return (_jsx(ProfileMenuItem, { title: relativeTitle, onClick: () => navigate(canApprovePaymentLinks ? '/conta-pj/aprovar-pagamentos' : '/conta-pj/minhas-solicitacoes'), info: paymentsCount > 0 ? formatPaymentsCount(paymentsCount) : undefined }));
};
export const ProfileMenuPaymentsItem = () => {
    return (_jsx(TranslationProvider, { translations: sharedUiTranslations, defaultLanguage: 'pt-BR', children: _jsx(ProfileMenuPaymentsItemBase, {}) }));
};
export default ProfileMenuPaymentsItem;
